import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PosterServices from '../../services/BannerServices';
import useAsync from '../../hooks/useAsync';
import Modal from 'react-modal';
import DeleteButton from '../Button/DeleteButton';
import UpdatePoster from '../Update Model/UpdatePoster';
import ViewPoster from '../View Model/ViewPoster';

Modal.setAppElement('#root');

function PosterList() {
    const { data, error, isLoading, run } = useAsync(PosterServices.getPosterList);
    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedPoster, setSelectedPoster] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const BASE_URL = process.env.REACT_APP_URL;

    // === Handlers ===
    const handleEditDetails = (poster) => {
        setSelectedPoster(poster);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };

    const handleDelete = (poster) => {
        setSelectedPoster(poster);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
    };

    const handleView = (poster) => {
        setSelectedPoster(poster);
        setIsViewModalOpen(true);
        toggleActionMenu(null);
    };

    const closeEditModal = () => { setIsEditModalOpen(false); setSelectedPoster(null); };
    const closeDeleteModal = () => { setIsDeleteModalOpen(false); setSelectedPoster(null); };
    const closeViewModal = () => { setIsViewModalOpen(false); setSelectedPoster(null); };

    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const list = data?.data || [];
    const filteredData = list.filter(poster =>
        (poster?.title || "").toLowerCase().includes(searchQuery.toLowerCase().trim())
    );

    return (
        <div className="right_col" role="main">
            <div className="d-md-flex align-items-center justify-content-between my-4 page-header-breadcrumb">
                <div className="my-auto">
                    <h5 className="page-title fs-21 mb-1">
                        Banner List <span className="badge bg-orange">{filteredData.length}</span>
                    </h5>
                    <nav>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item"><a href="#!">Home</a></li>
                            <li className="breadcrumb-item active" aria-current="page">Banner List</li>
                        </ol>
                    </nav>
                </div>
                <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                    <Link className="round-add-btn" to="/add-poster">
                        <img src="img/plus.svg" alt="Add banner" />
                    </Link>
                </div>
            </div>

            {/* Search */}
            <div className="container-box px-0 pt-2">
                <div className="Tablesearch_design mb-3">
                    <input
                        type="search"
                        placeholder="Search By Name"
                        value={searchQuery}
                        className="form-control"
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>

                {/* Table */}
                <div className="container-box-inner table-responsive-tabe">
                    <table className="table table-striped" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th>#</th>
                                {/* <th>Name</th> */}
                                   <th>Service Name</th>
                                <th>Image</th>
                                <th>Description</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((poster, i) => (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                  {/* <td>{poster?.serviceId?.vendorId?.name || "N/A"}</td> */}
                                  <td>{poster?.serviceId?.title || "N/A"}</td>
                                    <td>
                                        <img
                                            src={`${BASE_URL}${poster?.image || ""}`}
                                            alt={poster?.title}
                                            style={{ height: '70px', width: '70px', objectFit: 'contain' }}
                                        />
                                    </td>
                                <td>{poster?.title || "N/A"}</td>
                                    <td>
                                        <div className="action_toggle_outer">
                                            <button className="action_toggle" onClick={() => toggleActionMenu(i)}>
                                                <i className="fa fa-ellipsis-v" />
                                            </button>
                                            {activeIndex === i && (
                                                <div className="action_toggle_content product-edit show d-block">
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                                                <i className="fa fa-close" />
                                                            </button>
                                                        </li>
                                                        <li><button className="edit" onClick={() => handleEditDetails(poster)}>Edit</button></li>
                                                        <li><button className="reject" onClick={() => handleDelete(poster)}>Delete</button></li>
                                                        <li>
                                                            <button
                                                                className="approve"
                                                                style={{ backgroundColor: '#263238' }}
                                                                onClick={() => handleView(poster)}
                                                            >
                                                                View
                                                            </button>
                                                        </li>                                                  </ul>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modals */}
            <Modal isOpen={isEditModalOpen} onRequestClose={closeEditModal} className="modal-content" overlayClassName="modal-overlay">
                <UpdatePoster happy={selectedPoster} closeModal={closeEditModal} onSuccess={run} />
            </Modal>

            <Modal isOpen={isDeleteModalOpen} onRequestClose={closeDeleteModal} className="modal-content" overlayClassName="modal-overlay">
                <DeleteButton data={selectedPoster} page="delete-poster" closeModal={closeDeleteModal} onSuccess={run} />
            </Modal>

            <Modal
                isOpen={isViewModalOpen}
                onRequestClose={closeViewModal}
                contentLabel="View Poster"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <ViewPoster service={selectedPoster} closeModal={closeViewModal} />
            </Modal>
        </div>
    );
}

export default PosterList;